import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-d1b86bc2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    class: "pricing-summary-container",
    tabindex: "0"
};
const _hoisted_2 = {
    key: 0,
    class: "summary-container"
};
const _hoisted_3 = {
    key: 0,
    class: "discount-container"
};
const _hoisted_4 = { class: "discount display-name-input-styling viewer" };
const _hoisted_5 = {
    key: 1,
    class: "tax-container"
};
const _hoisted_6 = { class: "tax display-name-input-styling viewer" };
const _hoisted_7 = { class: "total-container" };
const _hoisted_8 = { class: "display-name-input-styling viewer" };
const _hoisted_9 = { class: "total-value" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.getSubtotalEnabled(_ctx.sectionSummary))
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.getShowSubtotalDiscount())
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.sectionSummary.discount.displayName), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["discount-value", { empty: _ctx.getSubtotalDiscountIsEmpty(_ctx.sectionSummary) }])
                        }, _toDisplayString(_ctx.getSubtotalDiscount(_ctx.sectionSummary, _ctx.currencySettings)), 3)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.getShowSubtotalTax(_ctx.columns, _ctx.sectionSummary, _ctx.isPreCalculated))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.sectionSummary.tax.displayName), 1),
                        _createElementVNode("div", {
                            class: _normalizeClass(["tax-value", { empty: _ctx.getSubtotalTaxIsEmpty(_ctx.sectionSummary) }])
                        }, _toDisplayString(_ctx.currencyFormat(_ctx.getSubtotalTax(_ctx.sectionSummary), _ctx.currencySettings)), 3)
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.sectionSummary.price.displayName), 1),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currencyFormat(_ctx.getSubtotalValue(_ctx.sectionSummary), _ctx.currencySettings)), 1)
                ])
            ]))
            : _createCommentVNode("", true)
    ]));
}
